module.exports = __webpack_public_path__ + "static/img/Exo2Bold.467f940.fnt";


//////////////////
// WEBPACK FOOTER
// ./src/commons/fonts/fonts/Exo2Bold.fnt
// module id = OMpI
// module chunks = 1